import React from "react";

import { TooltipContainer, TooltipText } from "./styles";

const Tooltip = ({ text, children }: any) => {
  return (
    <TooltipContainer>
      {children}
      <TooltipText>{text}</TooltipText>
    </TooltipContainer>
  );
};

export default Tooltip;
